const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '';

async function request(path, { method = 'GET', body, signal } = {}) {
  const url = `${API_BASE_URL}/${path}`;
  const response = await fetch(url, {
    method,
    headers: body instanceof FormData ? {} : { 'Content-Type': 'application/json' },
    body: body instanceof FormData ? body : body ? JSON.stringify(body) : undefined,
    signal,
  });

  if (!response.ok) {
    throw new Error(`Request failed (${response.status}) ${response.statusText}`);
  }

  const payload = await response.json();
  return payload?.data ?? [];
}

export const api = {
  getPresupuestos: ({ signal } = {}) => request('presupuestos', { signal }),
  getTipoConceptos: ({ signal } = {}) => request('tipo-conceptos', { signal }),
  getConceptos: ({ signal } = {}) => request('conceptos', { signal }),
  postTransaccion: async (body) => {
    const url = `${API_BASE_URL}/transacciones`;
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    return response;
  },
};